import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

import styles from "./continue-modal.css";

const ContinueModal = ({
    onContinue,
    onNew,
    title = "ぜんかいのつづきからできるファイルがあるよ！",
    continueLabel = "つづきから",
    newLabel = "はじめから",
}) => {
    const handleContinue = () => {
        onContinue && onContinue();
    };

    const handleNew = () => {
        onNew && onNew();
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalBody}>
                <h2 className={styles.title}>{title}</h2>

                <div className={styles.buttons}>
                    <button
                        className={classNames(styles.btn, styles.continueBtn)}
                        onClick={handleContinue}
                    >
                        {continueLabel}
                    </button>

                    <button
                        className={classNames(styles.btn, styles.newBtn)}
                        onClick={handleNew}
                    >
                        {newLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

ContinueModal.propTypes = {
    onContinue: PropTypes.func,
    onNew: PropTypes.func,
    title: PropTypes.string,
    continueLabel: PropTypes.string,
    newLabel: PropTypes.string,
};

export default ContinueModal;
